import React from "react";
import {
  ThemeProvider as DSThemeProvider,
  useTheme,
} from "@gcs/design-system/react";
import { ThemeProvider } from "styled-components";
import PortalPrivacidade from "./pages/PortalPrivacidade";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppContextProvider } from "./context/appContext";
import SecurityWrapper from "./components/SecurityWrapper/SecurityWrapper.js";
import NotFound from "./components/NotFound/NotFound.js";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary.js";

window.process = {};

function App() {
  const themeJvCaixa = "jv-caixa";
  
  return (
    <ErrorBoundary>
      <AppContextProvider>
        <BrowserRouter>
          <SecurityWrapper>
            <DSThemeProvider theme={themeJvCaixa}>
              <ThemeProvider theme={useTheme(themeJvCaixa)}>
                <Routes>
                  <Route path="/" element={<PortalPrivacidade />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ThemeProvider>
            </DSThemeProvider>
          </SecurityWrapper>
        </BrowserRouter>
      </AppContextProvider>
    </ErrorBoundary>
  );
}

export default App;